import React from "react";
import { ComponentTheme } from "components/fragments/dashboard/components/group-component/GroupComponentConfiguratorNew";
import { ZoneId } from "@js-joda/core";
import { InstantDoubleValue } from "api/model/dataset/InstantDoubleValue";
import { formatNumber, getTextColor } from "../charts/utils";
import CurrentValueTooltip from "./CurrentValueTooltip";

interface DatasetValueDisplayProps {
  id: string;
  val: InstantDoubleValue;
  highlightValue?: boolean;
  theme?: ComponentTheme;
  unit: string;
  tz: ZoneId;
  decimalPlaces?: number;
  diffDecimalPlaces?: number;
  convertToAbsoluteValues?: boolean;
  isMultiple?: boolean;
  setDialog: (isVisible: boolean) => void;
}

const DatasetValueDisplay = (props: DatasetValueDisplayProps) => {
  const tooltipId = `last-value-${props.id}-tooltip`;
  const textColor = props.highlightValue ? "" : getTextColor(props.theme);

  const datasetValueClassName = `value-container${props.isMultiple ? "-multiple" : ""} flex flex-row gap-1 align-items-end ${props.highlightValue ? "highlight-value" : ""}`;

  return (
    <React.Fragment key={props.id}>
      <div
        id={tooltipId}
        style={{ color: textColor }}
        className={datasetValueClassName}
        onDoubleClick={() => props.setDialog(true)}
      >
        <div className="value cursor-pointer font-bold">
          {props.val?.value !== undefined &&
            formatNumber(props.val.value, props.decimalPlaces, props.convertToAbsoluteValues)}
        </div>
        <div className="unit cursor-pointer font-bold">{props.unit}</div>
      </div>
      {props.val?.value && (
        <CurrentValueTooltip
          id={tooltipId}
          value={props.val?.value}
          valueKey={props.val?.key}
          unit={props.unit}
          diffDecimalPlaces={props.diffDecimalPlaces}
          tz={props.tz}
        />
      )}
    </React.Fragment>
  );
};

export default DatasetValueDisplay;
